module.exports = __webpack_public_path__ + "static/media/en_flag.482c15f3.svg";